'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagesService = function () {
  function ImagesService(Api) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ImagesService);
    this.api = Api;
  }

  (0, _createClass3.default)(ImagesService, [{
    key: 'loadCategories',
    value: function loadCategories(data) {
      return this.api.call({
        method: 'get',
        url: '/images/categories/' + data.currentPage + '/' + data.pageLimit + '/' + data.field + '/' + data.order_type
      });
    }
  }, {
    key: 'saveCategory',
    value: function saveCategory(data) {
      var url = '/images/saveCategory';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'removeCategory',
    value: function removeCategory(id) {
      var url = '/images/removeCategory/' + id;
      return this.api.call({
        method: 'delete',
        url: url
      });
    }
  }, {
    key: 'categoryById',
    value: function categoryById(id) {
      return this.api.call({
        method: 'get',
        url: '/images/category/' + id
      });
    }
  }, {
    key: 'updateCategory',
    value: function updateCategory(data) {
      var url = '/images/updateCategory';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'getImages',
    value: function getImages(data) {
      return this.api.call({
        method: 'get',
        url: '/images/getAll/' + data.currentPage + '/' + data.pageLimit + '/' + data.field + '/' + data.order_type + '/' + data.image_category_id
      });
    }
  }, {
    key: 'getImage',
    value: function getImage(id) {
      return this.api.call({
        method: 'get',
        url: '/images/getById/' + id
      });
    }
  }, {
    key: 'loadCategoriesNoLimit',
    value: function loadCategoriesNoLimit() {
      return this.api.call({
        method: 'get',
        url: '/images/categoriesNoLimit'
      });
    }
  }, {
    key: 'removeImage',
    value: function removeImage(id) {
      var url = '/images/removeImage/' + id;
      return this.api.call({
        method: 'delete',
        url: url
      });
    }
  }, {
    key: 'updateData',
    value: function updateData(data) {
      var url = '/images/updateData';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'updateImageOrder',
    value: function updateImageOrder(data) {
      var url = '/images/updateImageOrder';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'updateImageData',
    value: function updateImageData(data) {
      var url = '/images/updateImageData';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'checkRecordExist',
    value: function checkRecordExist(data) {
      var url = '/images/checkRecordExist';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }, {
    key: 'saveImageData',
    value: function saveImageData(data) {
      var url = '/images/saveImageData';
      return this.api.call({
        method: 'post',
        url: url,
        data: data,
        headers: {
          "Content-Type": 'application/json'
        }
      });
    }
  }]);
  return ImagesService;
}();

// WEBPACK FOOTER //


exports.default = ImagesService;


/** WEBPACK FOOTER **
 ** ./client/app/modules/images/services/images.service.js
 **/